import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class EmptyNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor() {
        this.model = [
            {            
            },
        ];
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/navigation/emptyNavigation.model.ts